export interface Playlist {
  id: string;
  titleKey: string;
  descriptionKey: string;
  icon: string;
  rooms: string[];
  estimatedMinutes: number;
  mood: 'calm' | 'intense' | 'reflective' | 'creative' | 'dark';
}

export const playlists: Playlist[] = [
  {
    id: 'morning-reflection',
    titleKey: 'playlist_morning',
    descriptionKey: 'playlist_morning_desc',
    icon: '🌅',
    rooms: ['one-honest-sentence', 'this-moment', 'breath-sync', 'color-of-today', 'your-inner-voice'],
    estimatedMinutes: 8,
    mood: 'calm',
  },
  {
    id: 'identity-deep-dive',
    titleKey: 'playlist_identity',
    descriptionKey: 'playlist_identity_desc',
    icon: '🪞',
    rooms: ['blurred-self', 'mask-you-wear', 'person-you-pretend-to-be', 'version-others-see', 'who-without-job'],
    estimatedMinutes: 12,
    mood: 'reflective',
  },
  {
    id: 'creative-spark',
    titleKey: 'playlist_creative',
    descriptionKey: 'playlist_creative_desc',
    icon: '🎨',
    rooms: ['the-blank-canvas', 'song-that-is-you', 'color-of-today', 'the-unwritten-poem', 'your-inner-voice'],
    estimatedMinutes: 10,
    mood: 'creative',
  },
  {
    id: 'courage-path',
    titleKey: 'playlist_courage',
    descriptionKey: 'playlist_courage_desc',
    icon: '🔥',
    rooms: ['fear-you-named', 'the-leap', 'courage-inventory', 'what-scares-you-most', 'facing-the-dark'],
    estimatedMinutes: 12,
    mood: 'intense',
  },
  {
    id: 'dream-journal',
    titleKey: 'playlist_dreams',
    descriptionKey: 'playlist_dreams_desc',
    icon: '🌙',
    rooms: ['recurring-dream-journal', 'lucid-moment', 'dream-you-wish-was-real', 'the-dream-visitor', 'nightmare-you-remember'],
    estimatedMinutes: 10,
    mood: 'reflective',
  },
  {
    id: 'future-vision',
    titleKey: 'playlist_future',
    descriptionKey: 'playlist_future_desc',
    icon: '🔮',
    rooms: ['letter-to-future-self', 'the-world-you-want', 'your-next-chapter', 'the-wish', 'if-you-had-one-year'],
    estimatedMinutes: 12,
    mood: 'reflective',
  },
  {
    id: 'truth-confrontation',
    titleKey: 'playlist_truth',
    descriptionKey: 'playlist_truth_desc',
    icon: '⚡',
    rooms: ['delay-button', 'reality-receipt', 'not-special', 'default-choice', 'expect-vs-happens'],
    estimatedMinutes: 10,
    mood: 'intense',
  },
  {
    id: 'night-journey',
    titleKey: 'playlist_night',
    descriptionKey: 'playlist_night_desc',
    icon: '🌑',
    rooms: ['empty-room', 'nothing-happens', 'static-room', 'void-room', 'the-silence-between'],
    estimatedMinutes: 15,
    mood: 'dark',
  },
];
